var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhp104F67C6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 60,
    height: 48,
    viewBox: "20.5 0 60 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#21376d",
    d: "M35.571 15.617c4.55.28 6.825 2.515 6.825 6.427 0 6.706-5.403 10.618-10.237 10.338H27.04l-1.137 5.868H20.5l4.55-22.633h10.521zm-2.275 4.192H29.6l-1.422 8.383h3.412c2.559-.28 4.834-1.118 5.118-5.868 0-1.677-1.421-2.515-3.412-2.515zm8.042 12.573 4.55-22.632h5.403l-1.137 5.867h5.118c4.55.28 6.256 2.515 5.687 5.309l-1.991 11.456h-5.687l1.991-10.338c.284-1.397.284-2.235-1.706-2.235H49.3l-2.559 12.574-5.403-.001c0 .001 0 0 0 0zm32.337-16.765c4.55.28 6.825 2.515 6.825 6.427 0 6.706-5.403 10.618-10.237 10.338h-5.119l-1.137 5.868h-5.403l4.55-22.633h10.521zM71.4 19.809h-3.697l-1.421 8.383h3.412c2.559-.28 4.834-1.118 5.118-5.868 0-1.677-1.422-2.515-3.412-2.515z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhp104F67C6);
export default __webpack_public_path__ + "static/media/php.104f67c6.e6da965094fce3e18de70f2fab01565d.svg";
export { ForwardRef as ReactComponent };